var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-menu',{staticStyle:{"z-index":"9999"},attrs:{"menu":_vm.getMenu,"collapsed":_vm.collapsed,"width":"18vw","widthCollapsed":"50px"},on:{"collapse":function($event){_vm.$emit('collapse')},"itemClick":_vm.onItemClick}})}
var staticRenderFns = []

export { render, staticRenderFns }